import styled from "@emotion/styled";

export const StyledExcel = styled.div`
  .loading {
    height: 100dvh;
  }
  .xg-root {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: hidden;
    height: calc(100dvh - 20px);

    .xg-toolbar {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 4px 8px;
      background: var(--primary);
      border-bottom: 1px solid #185c37;
      flex-shrink: 0;
      flex-wrap: wrap;
    }
    .xg-toolbar-title {
      color: #fff;
      font-weight: 700;
      font-size: 20px;
      margin-right: 6px;
      letter-spacing: 0.3px;
    }
    .xg-toolbar-sep {
      width: 1px;
      height: 20px;
      background: rgba(255, 255, 255, 0.3);
      margin: 0 2px;
    }
    .xg-btn {
      background: transparent;
      border: 1px solid transparent;
      color: #fff;
      padding: 4px 10px;
      border-radius: 3px;
      cursor: pointer;
      font-size: 11px;
      font-weight: 500;
      transition:
        background 0.15s,
        border-color 0.15s;
      display: flex;
      align-items: center;
      gap: 4px;
      white-space: nowrap;
    }
    .save-btn{
      border: 1px solid white !important;
    }
    .xg-btn:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
    }
    .xg-btn.danger:hover {
      background: rgba(255, 80, 80, 0.25);
      border-color: rgba(255, 100, 100, 0.4);
    }
    .xg-formula-bar {
      display: flex;
      align-items: center;
      padding: 3px 8px;
      background: #f3f3f3;
      border-bottom: 1px solid #d0d0d0;
      gap: 8px;
      flex-shrink: 0;
    }
    .xg-cell-ref {
      min-width: 64px;
      border: 1px solid #bbb;
      background: #fff;
      padding: 2px 6px;
      font-size: 12px;
      font-weight: 700;
      text-align: center;
      border-radius: 2px;
      color: #333;
      font-family: "Consolas", monospace;
    }
    .xg-formula-sep {
      color: #999;
      font-size: 13px;
      user-select: none;
    }
    .xg-formula-input {
      flex: 1;
      border: 1px solid #bbb;
      background: #fff;
      padding: 2px 6px;
      font-size: 12px;
      border-radius: 2px;
      outline: none;
      font-family: "Consolas", monospace;
      color: #333;
    }
    .xg-formula-input:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 2px rgba(33, 115, 70, 0.15);
    }
    .xg-grid-container {
      flex: 1;
      overflow: auto;
      position: relative;
    }
    .xg-table {
      border-collapse: collapse;
      min-width: max-content;
      table-layout: fixed;
    }
    .xg-col-header-row th {
      background: #f3f3f3;
      border: 1px solid #d0d0d0;
      font-size: 11px;
      font-weight: 600;
      color: #444;
      text-align: center;
      position: sticky;
      top: 0;
      z-index: 3;
      user-select: none;
      white-space: nowrap;
      overflow: hidden;
      padding: 0;
      height: 24px;
    }
    .xg-col-header-row th.xg-selected-col {
      background: #d6e4bc;
      color: #1a5c2e;
    }
    .xg-row-num-header {
      width: 40px !important;
      min-width: 40px;
      max-width: 40px;
      left: 0;
      z-index: 4 !important;
      background: #f3f3f3 !important;
    }
    .xg-col-header-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 4px;
      position: relative;
    }
    .xg-col-header-inner span {
      flex: 1;
      text-align: center;
      font-size: 11px;
    }
    .xg-resize-handle {
      position: absolute;
      right: 0;
      top: 0;
      width: 5px;
      height: 100%;
      cursor: col-resize;
      background: transparent;
      z-index: 5;
      transition: background 0.1s;
    }
    .xg-resize-handle:hover,
    .xg-resize-handle.active {
      background: var(--primary);
      opacity: 0.8;
    }
    .xg-row-num {
      background: #f3f3f3;
      border: 1px solid #d0d0d0;
      font-size: 11px;
      font-weight: 600;
      color: #444;
      text-align: center;
      width: 40px;
      min-width: 40px;
      max-width: 40px;
      position: sticky;
      left: 0;
      z-index: 2;
      user-select: none;
      cursor: pointer;
      padding: 2px 0;
    }
    .xg-row-num:hover,
    .xg-row-num.xg-selected-row {
      background: #d6e4bc;
      color: #1a5c2e;
    }
    td.xg-cell {
      border: 1px solid #d0d0d0;
      padding: 0;
      font-size: 12px;
      color: #1e1e1e;
      background: #fff;
      cursor: default;
      overflow: hidden;
      white-space: nowrap;
      position: relative;
    }
    td.xg-cell:focus {
      outline: none;
    }
    td.xg-cell.xg-selected {
      border: 2px solid var(--primary) !important;
      z-index: 1;
    }
    td.xg-cell.xg-in-selection {
      background: #e8f5e0;
    }
    td.xg-cell.xg-editing {
      border: 2px solid #1e6fcf !important;
      z-index: 2;
      overflow: visible;
    }
    .xg-cell-display {
      width: 100%;
      height: 100%;
      padding: 2px 6px;
      display: flex;
      align-items: center;
      min-height: 22px;
    }
    .xg-cell-display.xg-right {
      justify-content: flex-end;
    }
    .xg-cell-editor {
      position: absolute;
      top: -1px;
      left: -1px;
      border: none;
      outline: none;
      font-size: 14px;
      font-family: "Segoe UI", sans-serif;
      padding: 3px 6px;
      background: #fff;
      z-index: 10;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
      color: #1e1e1e;
    }
    .xg-add-col-th {
      background: #f3f3f3 !important;
      border: 1px solid #d0d0d0;
      position: sticky !important;
      top: 0;
      z-index: 3 !important;
      cursor: pointer;
      width: 32px !important;
      min-width: 32px;
      color: var(--primary);
      font-size: 16px;
      font-weight: bold;
      transition: background 0.15s;
    }
    .xg-add-col-th:hover {
      background: #d6e4bc !important;
    }
    .xg-add-row-td {
      text-align: center;
      font-size: 16px;
      color: var(--primary);
      font-weight: bold;
      cursor: pointer;
      background: #f9f9f9;
      border: 1px solid #e0e0e0;
      padding: 4px;
      transition: background 0.15s;
    }
    .xg-add-row-td:hover {
      background: #d6e4bc;
    }
    .xg-ctx-menu {
      position: fixed;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-shadow: 2px 4px 18px rgba(0, 0, 0, 0.15);
      z-index: 9999;
      min-width: 170px;
      overflow: hidden;
      animation: xgCtxIn 0.1s ease;
    }
    @keyframes xgCtxIn {
      from {
        opacity: 0;
        transform: scale(0.96);
      }
      to {
        opacity: 1;
        transform: scale(1);
      }
    }
    .xg-ctx-item {
      padding: 7px 16px;
      font-size: 12px;
      cursor: pointer;
      color: #222;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: background 0.1s;
    }
    .xg-ctx-item:hover {
      background: #e8f5e0;
      color: var(--primary);
    }
    .xg-ctx-item.danger:hover {
      background: #fff0f0;
      color: #c0392b;
    }
    .xg-ctx-sep {
      height: 1px;
      background: #eee;
      margin: 2px 0;
    }
    .xg-status-bar {
      display: flex;
      align-items: center;
      padding: 2px 12px;
      background: var(--primary);
      color: rgba(255, 255, 255, 0.85);
      font-size: 11px;
      gap: 16px;
      flex-shrink: 0;
      border-top: 1px solid #185c37;
    }
    .xg-status-item {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .xg-status-val {
      color: #fff;
      font-weight: 700;
    }
  }
`;
